import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const platformSettingsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    editPlatformSettings: builder.mutation({
      query: (data) => ({
        url: apiRoutes.platformSettings.createandUpdate.path,
        method: apiRoutes.platformSettings.createandUpdate.reqType,
        body: data,
      }),
      invalidatesTags: [{ type: "PlatformSettings", id: "SETTINGS" }],
    }),
    getAllPlatformSettings: builder.query({
      query: (params) => ({
        url: apiRoutes.platformSettings.get.path,
        method: apiRoutes.platformSettings.get.reqType,
        params,
      }),
      providesTags: [{ type: "PlatformSettings", id: "SETTINGS" }],
    }),
  }),
});

export const {
  useEditPlatformSettingsMutation,
  useGetAllPlatformSettingsQuery,
  useLazyGetAllPlatformSettingsQuery,
} = platformSettingsApiSlice;
